import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      {/* Hero Section */}
      <div className="max-w-6xl mx-auto pt-20 pb-16 px-5">
        <div className="text-center mb-20">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-gray-900 leading-tight">
            About <span className="bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
                TravelMaker
              </span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            We're on a mission to transform how people explore and experience new destinations
          </p>
        </div>

        {/* Our Story Section */}
        <section className="mb-32">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Story</h2>
            <div className="w-24 h-1 bg-primary mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                TravelMaker was born out of a shared passion for travel and technology. We as avid travelers ourselves,
                often found it challenging to truly experience the essence of new cities without spending hours on research or
                missing out on hidden gems that only locals know about.
              </p>

              <p className="text-lg text-gray-700 leading-relaxed">
                In 2024, after a particularly frustrating trip where we missed several must-see attractions despite extensive
                planning, we decided there had to be a better way. We envisioned an app that would serve as a personal travel
                companion, guiding users through cities with curated points of interest.
              </p>

              <p className="text-lg text-gray-700 leading-relaxed">
                After months of development and testing in various cities around the world, TravelMaker was launched with the
                goal of making travel more enriching, efficient, and enjoyable for everyone.
              </p>
            </div>

            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-transparent rounded-2xl transform rotate-3"></div>
              <img
                src="/images/about-image.jpg"
                alt="TravelMaker team brainstorming"
                className="relative w-full rounded-2xl shadow-2xl transform -rotate-1 hover:rotate-0 transition-transform duration-300"
              />
            </div>
          </div>
        </section>

        {/* Our Mission Section */}
        <section className="mb-32">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Mission</h2>
            <div className="w-24 h-1 bg-primary mx-auto rounded-full"></div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-primary/10 to-primary/5 rounded-3xl"></div>
            <div className="relative bg-white/80 backdrop-blur-sm py-16 px-8 md:px-16 rounded-3xl shadow-xl border border-gray-100">
              <div className="text-center">
                <div className="text-6xl mb-8">🌍</div>
                <blockquote className="text-xl md:text-2xl italic max-w-4xl mx-auto text-gray-700 leading-relaxed font-medium">
                  "To empower travelers to discover every destination through technology that connects them with local culture,
                  history, and experiences that make each journey unforgettable."
                </blockquote>
              </div>
            </div>
          </div>
        </section>


      </div>
    </div>
  );
};

export default About;